module.exports = __webpack_public_path__ + "static/media/refurbishBathroom(UPLOAD).2c05222f.jpg";